module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"midSeasonSale":"MID-SEASON SALE","up50":"UP TO 50%","shopNow":"SHOP NOW","checkout":"CHECK OUT","newCollection":"NEW COLLECTION"},"de":{"midSeasonSale":"SOMMERSCHLUSSVERKAUF","up50":"BIS ZU 50%","shopNow":"JETZT SHOPPEN","checkout":" ","newCollection":"NEUE KOLLEKTION"}}')
  delete Component.options._Ctor
}
